module.exports = __webpack_public_path__ + "static/media/ic_remove.2f0c70bf.png";